/* GENTCREATE — the star rating under the product title takes you to the reviews.
 *
 * The Rapid Reviews app prepends an <a tabindex="0"> into
 * .rapid-reviews-placeholder with NO href, so the one thing on the page that
 * looks like a link to the reviews did nothing at all when clicked.
 *
 * Where it goes depends on the screen, because the two screens put the social
 * proof in different places: on a phone the customer stories rail sits right
 * there in the product column and is the nearest, richest answer to "what did
 * people think"; on a desktop the rail is one small row and the written reviews
 * at the foot of the page are the real destination.
 *
 * The app owns the review list and renders it late, so the target is looked up
 * at click time, never cached. */
(function () {
  'use strict';

  var PHONE = '(max-width: 719px)';

  /* The reviews section has no id: templates/product.json puts the app block
     inside a bare div.Container from sections/apps.liquid. So it is found by
     the app's own class names, in the order they are most likely to exist,
     with the section container as a last resort. */
  var REVIEW_SELECTORS = [
    '.rapid_reviews_items',
    '.r_items_list',
    '.rapid_reviews_widget',
    '[class*="rapid_reviews"]:not(.rapid_reviews_stars_badge):not(.rapid-reviews-placeholder)',
  ];

  function reviewsTarget() {
    for (var i = 0; i < REVIEW_SELECTORS.length; i++) {
      var el = document.querySelector(REVIEW_SELECTORS[i]);
      /* skip the copy of the badge that lives in the cart drawer */
      if (el && !el.closest('#bottom-cart') && el.getBoundingClientRect().height > 0) return el;
    }
    return null;
  }

  function headerOffset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var n = parseInt(v, 10);
    return (isNaN(n) ? 64 : n) + 12;
  }

  function goTo(el) {
    if (!el) return false;
    /* Centred in the window rather than tucked under the header, so the thing
       you asked for lands where you are already looking. A block taller than
       the screen cannot be centred, so that one goes back to sitting under the
       header - the max() picks whichever of the two is the larger offset. */
    var r = el.getBoundingClientRect();
    var centre = (window.innerHeight - r.height) / 2;
    var y = r.top + window.pageYOffset - Math.max(headerOffset(), centre);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); }
    catch (e) { window.scrollTo(0, y); }
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var holder = e.target.closest('.rapid-reviews-placeholder');
    if (!holder) return;
    /* the drawer carries its own copy of the badge; leave that one alone */
    if (holder.closest('#bottom-cart')) return;

    var phone = window.matchMedia && window.matchMedia(PHONE).matches;
    var target = phone ? document.querySelector('[data-gc-ugc]') : reviewsTarget();
    /* if the phone has no stories rail on this product, the written reviews are
       still a better answer than nothing */
    if (!target) target = phone ? reviewsTarget() : document.querySelector('[data-gc-ugc]');
    if (!goTo(target)) return;

    /* No highlight on arrival. The scroll itself is the answer, and the ring
       drew attention to the fact that something had been done to the page
       rather than to the reviews. */

    e.preventDefault();
    e.stopPropagation();
  }, true);

  /* It has looked unclickable because it was. The app's anchor has no href, so
     it gets neither a pointer nor a keyboard affordance from the browser. */
  function dress() {
    var holders = document.querySelectorAll('.rapid-reviews-placeholder');
    for (var i = 0; i < holders.length; i++) {
      var h = holders[i];
      if (h.closest('#bottom-cart') || h.getAttribute('data-gc-jump') === '1') continue;
      if (!h.querySelector('a, button')) continue;
      h.setAttribute('data-gc-jump', '1');
      h.style.cursor = 'pointer';
      var a = h.querySelector('a');
      if (a && !a.getAttribute('href')) {
        a.setAttribute('role', 'button');
        a.addEventListener('keydown', function (ev) {
          if (ev.key !== 'Enter' && ev.key !== ' ') return;
          ev.preventDefault();
          this.click();
        });
      }
    }
  }

  /* ---- "Ask a Question" goes to the inbox, not to a new tab ---- */
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest && ev.target.closest('a[href*="/a/reviews/"]');
    if (!a) return;
    var path;
    try { path = new URL(a.href, location.origin).pathname; } catch (e) { return; }
    /* /a/reviews/q, or /a/reviews/<shop>/q when the app has no shop_domain.
       "r" is write-a-review and must keep going where it was going. */
    if (!/\/q$/.test(path)) return;
    if (typeof window.gcOpenChat === 'function' && window.gcOpenChat()) {
      ev.preventDefault();
      return;
    }
    var tile = document.querySelector('[data-gc-support]');
    if (tile) { ev.preventDefault(); tile.click(); return; }
    /* no inbox on the page — leave the link alone rather than swallow the click */
  }, true);

  /* the badge is injected by the app whenever it gets round to it */
  if (window.MutationObserver) {
    new MutationObserver(dress).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dress);
  else dress();
})();
